import apiHandler from "../core/apiHandler";

const customerDashboardApi = apiHandler('dashboard/customers');
export default customerDashboardApi;
